// Paths sourced from /src/assets/svg/arrow-sort*.svg
// Left path  = up-arrow + left stem  → highlighted when ascending
// Right path = right stem + down-arrow → highlighted when descending

const LEFT_PATH =
  'M8 6.57819L5.45733 4.03552C5.36448 3.94256 5.25422 3.8688 5.13286 3.81847C5.01149 3.76814 4.88139 3.74222 4.75 3.74219M4.75 3.74219C4.494 3.74219 4.238 3.84085 4.04267 4.03619L1.5 6.57885M4.75 3.74219V12.6729';
const RIGHT_PATH =
  'M11.25 3.65625V12.5856M11.25 12.5856C11.506 12.5856 11.762 12.4883 11.9573 12.2929L14.5 9.75025M11.25 12.5856C10.994 12.5856 10.738 12.4876 10.5427 12.2923L8 9.74958';

const COLOR_ACTIVE = '#2A4455';
const COLOR_DEFAULT = '#878B8E';

interface SortIconProps {
  /** The column key this icon belongs to */
  column: string;
  /** Currently active sort column (null = no sort active) */
  sortColumn: string | null;
  /** Current sort direction */
  sortDirection: 'asc' | 'desc';
}

/**
 * Reusable sort icon that renders one of three states:
 * - neutral  (column !== sortColumn): both sides #878B8E
 * - ascending (column === sortColumn, dir=asc): left side #2A4455
 * - descending (column === sortColumn, dir=desc): right side #2A4455
 */
export function SortIcon({ column, sortColumn, sortDirection }: SortIconProps) {
  const isActive = sortColumn === column;
  const leftStroke =
    isActive && sortDirection === 'asc' ? COLOR_ACTIVE : COLOR_DEFAULT;
  const rightStroke =
    isActive && sortDirection === 'desc' ? COLOR_ACTIVE : COLOR_DEFAULT;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d={LEFT_PATH}
        stroke={leftStroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={RIGHT_PATH}
        stroke={rightStroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
